import * as React from "react";
import {
    getPrintDate,
    handleCaseType,
    handleClaimStatus,
    handleClaimType,
    handleComplaintStatus, handleIncaseofshipment, handleIssueType
} from "../detail/form_utility";
import { SectionWrapper } from "./index";
import { IRootState } from "../../reducers";
import { connect } from "react-redux";

class MainformPreviewComponent extends React.Component<any, any> {

    public render() {
        const { values } = this.props.mainForm.mainForm;
        return (
            <SectionWrapper>
                <div className="PrintSectionHeader">Main Form </div>
                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">Submitter:</div>
                        <div className="PrintItemValue">{values.createdBy}</div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">Case created:</div>
                        <div className="PrintItemValue">{getPrintDate(values.created)}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel"> Submitting on behalf of:</div>
                        <div className="PrintItemValue">{values.contactPerson}</div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">Case No:</div>
                        <div className="PrintItemValue">{values.caseNo}</div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Contact Person:
                        </div>
                        <div className="PrintItemValue">
                            {values.contactPerson}
                        </div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Case Type:
                        </div>
                        <div className="PrintItemValue">
                            {handleCaseType(values.caseType)}
                        </div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Phone:
                        </div>
                        <div className="PrintItemValue">
                            {values.phone}
                        </div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Complaint status:
                        </div>
                        <div className="PrintItemValue">
                            {handleComplaintStatus(values.complaintStatus)}
                        </div>
                    </div>
                </div>

                {values.complaintClosureDate &&
                    <div className="PrintContainerWrapper">
                        <div className="PrintItemContainer">
                            <div className="PrintItemLabel">
                                Complaint closure date:
                            </div>
                            <div className="PrintItemValue">
                                {getPrintDate(values.complaintClosureDate)}
                            </div>
                        </div>
                    </div>
                }

                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Countries Affected:
                        </div>
                        <div className="PrintItemValue">
                            {values.countriesAffected.map((country: any) => country.countryName).join(', ')}
                        </div>
                    </div>
                </div>

                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Email:
                        </div>
                        <div className="PrintItemValue">
                            {values.email}
                        </div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Claim Status:
                        </div>
                        <div className="PrintItemValue">
                            {handleClaimStatus(values.claimStatus)}
                        </div>
                    </div>
                </div>

                {values.claimClosed &&
                    <div className="PrintContainerWrapper">
                        <div className="PrintItemContainer">
                            <div className="PrintItemLabel">
                                Claim closure date:
                            </div>
                            <div className="PrintItemValue">
                                {getPrintDate(values.claimClosed)}
                            </div>
                        </div>
                    </div>
                }

                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Claim Type:
                        </div>
                        <div className="PrintItemValue">
                            {handleClaimType(values.claimType)}
                        </div>
                    </div>
                </div>

                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Region:
                        </div>
                        <div className="PrintItemValue">
                            {values.regions}
                        </div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Insurance policy year (YYYY):
                        </div>
                        <div className="PrintItemValue">
                            {values.insurancePolicyYear}

                        </div>
                    </div>
                </div>

                <div className="PrintContainerWrapper commentWrapper">
                    <div className='PrintCommentContainer'>
                        <div className='PrintCommentLabel'>
                            Description of the issue:
                        </div>
                        <div className="PrintCommentValue">
                            {values.descriptionOfTheIssue}
                        </div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Date issue noticed:
                        </div>
                        <div className="PrintItemValue">
                            {getPrintDate(values.dateIssueNoticed)}
                        </div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Expected loss value:
                        </div>
                        <div className="PrintItemValue">
                            {values.expectedLossCurrency}{values.expectedLossValue}
                        </div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Issue Type:
                        </div>
                        <div className="PrintItemValue">
                            {handleIssueType(values.issueType)}
                        </div>
                    </div>
                </div>
                <div className="PrintContainerWrapper">
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            Internal Comments:
                        </div>
                        <div className="PrintItemValue">
                            {values.internalComments}
                        </div>
                    </div>
                    <div className="PrintItemContainer">
                        <div className="PrintItemLabel">
                            In case of shipment:
                        </div>
                        <div className="PrintItemValue">
                            {handleIncaseofshipment(values.inCaseOfShipment)}
                        </div>
                    </div>
                </div>

                <div className="PrintContainerWrapper commentWrapper">
                    <div className='PrintCommentContainer'>
                        <div className='PrintCommentLabel'>
                            Comments:
                        </div>
                        <div className="PrintCommentValue">
                            {values.comments}
                        </div>
                    </div>
                </div>
            </SectionWrapper>
        )
    }
}

// export default MainformPreviewComponent;

const mapStateToProps = (state: IRootState) => {
    return {
        mainForm: state.form
    };
};

// connect the form wrapper to the state store
export default connect(
    mapStateToProps,
    null
)(MainformPreviewComponent)